import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import "./index.css";
import CaseStatus from "./pages/Dashboard/CaseStatus";
import Root from "./pages/index";
import Router from "./pages/Router/index";
import DealerMapping from "./pages/DealerMapping";
import CustomerNotification from "./pages/Customer/CustomerNotification";
import { Provider } from "react-redux";
import storeFactory from "./Redux/store";


console.log(process.env.REACT_APP_ENV);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      // {
      //   path: "/casestatus/dashboard/:type",
      //   element: <Dashboard />,
      //   errorElement: <ErrorPage />,
      // },
      {
        path: "/cwc-support/dashboard",
        element: <CaseStatus />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/cwccustomernotification",
        element: <CustomerNotification />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/delaerMapping",
        element: <DealerMapping />,
        errorElement: <ErrorPage />,
      },
      //  {
      //   path: "/businessMisStateWise",
      //   element: <StateWiseListing />,
      //   errorElement: <ErrorPage />,
      // },
    ],
  },
  {
    path: "/cwc-support/token",
    element: <Router />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
const store = storeFactory();
root.render(
  <Provider store={store}>
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
